import { css } from '@emotion/react'
import { merge } from 'lodash-es'
import { type HTMLMotionProps, motion } from 'motion/react'
import { forwardRef } from 'react'

export interface ClickWrapperProps extends HTMLMotionProps<'div'> {}

export default forwardRef<HTMLDivElement, ClickWrapperProps>(function ClickWrapper(
	{ ...props }: ClickWrapperProps,
	ref
) {
	return (
		<motion.div
			{...props}
			whileTap={merge(
				{},
				{
					scale: 0.98,
				},
				props.whileTap
			)}
			ref={ref}
			css={css`
				cursor: pointer;
				user-select: none;
				height: fit-content;
			`}
		/>
	)
})
